<template>
  <InfuseTooltip :content="tooltipText" :disabled="!tooltipText" :icon="icon" :title="tooltipTitle" offset-distance="8">
    <button
      v-bind="$attrs"
      class="flex items-center justify-center rounded-md transition duration-150 ease-out-quart active:scale-[0.97] disabled:active:scale-100 motion-reduce:active:scale-100"
      :class="[
        size === 'xs' ? 'h-5 w-5' : '',
        size === 'sm' ? 'h-6 w-6' : '',
        size === 'md' ? 'h-8 w-8' : '',
        size === 'lg' ? 'h-10 w-10' : '',
        color === 'primary'
          ? 'bg-secondary-500 text-white hover:bg-secondary-400 active:bg-secondary-600 active:text-white disabled:bg-primary-50 disabled:text-neutral-300'
          : '',
        color === 'secondary'
          ? 'border-secondary-500 bg-white text-secondary-500 hover:border-secondary-300 hover:text-secondary-300 active:border-secondary-500 active:bg-secondary-500 active:text-white disabled:border-secondary-100 disabled:text-secondary-100'
          : '',
        color === 'alter'
          ? 'border-error-500 text-error-700 hover:border-error-700 hover:text-error-300 active:border-error-700 disabled:border-error-50 disabled:text-error-50'
          : '',
        border ? 'border' : ''
      ]"
      :disabled="disabled"
      type="button"
      @click="onClick($event)"
      @mouseover="isHovering = true"
      @mouseleave="isHovering = false"
    >
      <font-awesome-icon :icon="icon" :size="size === 'md' ? '1x' : size || 'xs'" />
    </button>
  </InfuseTooltip>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';

import InfuseTooltip from './InfuseTooltip.vue';

const emit = defineEmits(['click']);

interface Props {
  border?: boolean;
  color?: 'primary' | 'secondary' | 'alter';
  disabled?: boolean;
  icon?: string[];
  size?: 'xs' | 'sm' | 'md' | 'lg';
  tooltipText?: string;
  tooltipTitle?: string;
}

withDefaults(defineProps<Props>(), {
  label: '',
  border: true,
  color: 'primary',
  icon: () => ['fas', 'fasCircleExclamation'],
  size: 'sm',
  tooltipText: undefined,
  tooltipTitle: undefined
});

const isHovering = ref<boolean>(false);

function onClick(event: Event) {
  emit('click', event);
}
</script>
